import React from "react"
import clsx from "clsx"
import * as styles from "./icons.module.scss"

export const EmptyIconPravdaCoffee = ({ variant }: { variant?: string }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={clsx(styles.empty, variant && styles[variant])}
  >
    <mask id="path-1-inside-1_13723_2265" fill="white">
      <path d="M2 6C2 3.79086 3.79086 2 6 2H18C20.2091 2 22 3.79086 22 6V18C22 20.2091 20.2091 22 18 22H6C3.79086 22 2 20.2091 2 18V6Z" />
    </mask>
    <path
      d="M6 2V4H18V2V0H6V2ZM22 6H20V18H22H24V6H22ZM18 22V20H6V22V24H18V22ZM2 18H4V6H2H0V18H2ZM6 22V20C4.89543 20 4 19.1046 4 18H2H0C0 21.3137 2.68629 24 6 24V22ZM22 18H20C20 19.1046 19.1046 20 18 20V22V24C21.3137 24 24 21.3137 24 18H22ZM18 2V4C19.1046 4 20 4.89543 20 6H22H24C24 2.68629 21.3137 0 18 0V2ZM6 2V0C2.68629 0 0 2.68629 0 6H2H4C4 4.89543 4.89543 4 6 4V2Z"
      fill="#9FA0A7"
      mask="url(#path-1-inside-1_13723_2265)"
    />
  </svg>
)
